export default function(state=null, action) {

    switch(action.type) {
        case "FORM_FILE":
            return action.payload

        case "RESET_FORM":
            return state

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerFormFile.js